<template>
  <b-row class="section" :class="['section-' + pageMode, {'mx-xl-auto': isGeneric && !isPDF}]">
    <b-col v-if="dividerline" cols="24" class="divider-line-col">
      <div class="divider-line"></div>
    </b-col>
    <b-col cols="24" class="main-section-col" :class="[colClass, {'section-content row no-gutters': hasResponsiveTitle}]">

        <div v-if="(title !== '')" class="title-head" :class="responsiveTitleClass">
          <b-row class="title-head-row" :class="{'mx-2 mx-sm-4': isGeneric && !isPDF}">
            <b-col v-if="!!this.$slots.icon && isGeneric" cols="auto" class="d-inline-block align-top my-sm-1 svg-wrapper" :class="this.iconClass">
              <slot name="icon"></slot>
            </b-col>
            <b-col :class="{'px-sm-3 px-2': isGeneric, 'pl-0': isSAGE}">
              <b-row>
                <b-col cols="24" class="d-inline-block text-left title-content" :class="[
                  isGeneric && !isPDF && !(secondaryTitle || subtitle) ? 'pb-3' : '',
                  {
                    'col-sm pt-3 py-sm-4': isGeneric && !isPDF
                  }
                ]">
                  <h2 class="title" v-html="title"></h2>
                </b-col>
                <b-col cols="24" class="text-left title-content" :class="[
                  isGeneric && !isPDF && !(secondaryTitle || subtitle) ? 'd-none' : 'd-inline-block',
                  {
                    'text-sm-right col-sm py-sm-3': isGeneric && !isPDF, 
                    'editable': !!this.$slots.editButton
                  }
                ]">
                  <p v-if="(secondaryTitle !== '')" class="secondary-title" v-html="secondaryTitle"></p>
                  <p v-if="(subtitle !== '')" class="subtitle" :class="{
                    'ml-sm-auto pt-2': !isPDF, 
                    'pb-2 py-sm-3 d-table': !isPDF && isGeneric
                  }">
                    <span class="d-table-cell" v-html="subtitle"></span>
                  </p>
                  <b-row align-h="end">
                    <b-col cols="7">
                      <div v-if="!!showRateInfoLink" class="apr-link mt-sm-n3">
                        <div class="mb-3 mb-sm-0">
                          <a :href="showRateInfoLinkText" target="_blank">
                            <span class="btn-edit"><font-awesome-icon :icon="['fas','info-circle']" class="avm-tooltip-icon cursor-pointer mr-1" /> Rates Info</span>
                          </a>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="7" v-if="!!this.$slots.editButton">
                      <div v-if="!!this.$slots.editButton" class="edit-button mt-sm-n3">
                        <slot name="editButton"></slot>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <div class="section-content" v-if="!!this.$slots.content && !hasResponsiveTitle">
          <slot name="content"></slot>
        </div>
        <slot v-if="!!this.$slots.content && hasResponsiveTitle" name="content"></slot>

    </b-col>
  </b-row>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    secondaryTitle: {
      type: String,
      default: ''
    },
    colClass: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: 'my-2'
    },
    dividerline: {
      type: Boolean,
      default: true
    },
    modeOverride: {
      type: String,
      default: ''
    },
    responsiveTitle: {
      type: String,
      default: undefined
    }
  },
  inject: {
    'isPDF': { default: false },
    showRateInfoLink: {
      from: 'showRateInfoLink',
      default: ''
    },
  },
  computed: {
    pageMode () {
      return (this.modeOverride !== '') ?
        this.modeOverride :
        this.$store.state.mode;
    },
    showRateInfoLinkText() {
      return this.showRateInfoLink 
    },
    isGeneric () {
      return this.pageMode === 'generic';
    },
    isSAGE() {
      return !this.isGeneric;
    },
    hasResponsiveTitle () {
      return (this.responsiveTitle !== undefined);
    },
    responsiveTitleClass () {
      if(this.responsiveTitle === undefined) {
        return '';
      }
      else if(this.responsiveTitle === '') {
        return 'col-md-8'; //default
      }
      else {
        return this.responsiveTitle;
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_custom-variables.scss';
@import '@/styles/_custom-mixins.scss';

//.section styles will apply to the section regardless of mode
.section {
  padding-top:30px;
  position:relative;

  .title-content .title {
    font-family: $secondary-font;
    font-size: 32px;
    margin-bottom: 20px;
  }

  .title-content .subtitle {
    font-family: $primary-font;
    font-size: 14px;
    line-height: 24px;
  }
}

// for generic mode, including PDF view
.section-generic {
  padding-top: 10px;
  margin-left: -10px;
  margin-right: -10px;

  .main-section-col
  {
    padding-left: 0;
    padding-right: 0;
  }

  .svg-wrapper {
    padding-top: 21px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }

  .title-content .title {
    font-family: $primary-font;
    font-size: 36px;
    line-height: 36px;
    margin-bottom: 20px;
  }

  .title-content .subtitle {
    font-family: $secondary-font;
    font-size: 14px;
    line-height: 24px;
  }
}

//styles explicitly NOT applied to PDF view
#app > div:not(#BMA_PDF){
  // only for generic mode
  .section-generic {
    box-shadow: 0px 0px 40px rgba(85, 124, 149, .1);
    max-width: 1440px;
    border-radius: 4px;
    margin-bottom: 30px;
    padding-top: 0;
    overflow: hidden;

    .title-head {
      min-height: 72px;
      @media only screen and (min-width: $breakpoint-sm) {
        min-height: 92px;
      }
    }

    .title-head,
    .section-content > div:not(:last-child):not(.blur_section)
    {
      border-bottom: 1px solid #DDDDDD;
    }

    .section-content {
      position: relative;
    }

    .title-content .title {
      margin-top: 5px;
      margin-bottom: 0;
    }

    .title-content .subtitle {
      line-height: 18px;
      margin-bottom: 0;
      > span {
        vertical-align: middle;
      }
      @media only screen and (min-width: $breakpoint-sm){
        height: 100%;
      }
    }
    .title-content.editable .subtitle {
      top: 33%;
      //overwrites 50% from the vertical-align() mixin
      //to make space for the edit button... a bit hacky
    }
  }
}

// only for Berkshire mode
.section-berkshire {
  padding-top: 0;

  .title-content .title {
    font-weight: normal;
    line-height: 40px;
    font-size: 40px;
    margin-bottom: 8px;
  }

  .divider-line-col {
    padding-top: 50px;
    .divider-line {
      @include bh-section-bar();

    }
  }

}

// ONLY FOR MOBILE
@media only screen and (max-width : 767px) {
  .section-generic {
    .title-content .title {
      font-size: 28px;
      line-height: 28px;
    }
  }

  .section-berkshire {
    .secondary-title {
      font-size: 30px;
      line-height: 30px;
      margin-top: 8px;
    }

    .subtitle,
    .title-content .subtitle {
      font-size: 18px;
      line-height: 24px;
    }
  }
}

// BIGGER THAN MOBILE
@media only screen and (min-width: $breakpoint-sm) {
  .section-generic {
    .svg-wrapper {
      padding-top: 29px;
    }
  }
}

</style>
